
export  const setToken=(token)=>{
    localStorage.setItem('token',token);
}

export  const getToken=(token)=>{
    return localStorage.getItem('token');
}

export  const clearStorage=()=>{
    localStorage.setItem('token','');
    localStorage.setItem('login_data','');
    localStorage.setItem('otp_key','');
    localStorage.clear();
}

export  const setLoginData=(data)=>{
    localStorage.setItem('login_user',data);
}

export  const getLoginData=()=>{
    return localStorage.getItem('login_user');
}


export  const setOtpKey=(otp_key)=>{

    console.log('Set key')
    localStorage.setItem('otp_key',otp_key);
}

export  const getOtpKey=()=>{
    return localStorage.getItem('otp_key');
}